import React, { Component } from 'react'
import { Card, Loading } from '@myxplor/ui'

import LocalAsyncStore from '../../local-async-store'
import { currentReport, availableReports } from './helpers'
import RenderReport from './views'
import { NoReports } from './views/empty'
import './views/provider-level-reports.css'

export class ProviderLevelReportsWrapper extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentReport: currentReport(props),
      reports: availableReports(props.reports_available.data),
    }
    this.setCurrentReport = this.setCurrentReport.bind(this)
    this.resetCurrentReport = this.resetCurrentReport.bind(this)
  }

  componentDidUpdate(prevProps) {
    // if reports_available has loaded and there is only one report to view
    // we will render the report without forcing the user to select
    const { reports_available } = this.props

    if (reports_available !== prevProps.reports_available) {
      const reports = availableReports(reports_available.data)

      this.setState({
        reports,
        currentReport: reports.length === 1 ? currentReport({ report_id: reports[0].id }) : null,
      })
    }
  }

  setCurrentReport(report_id) {
    this.setState({ currentReport: currentReport({ report_id }) })
  }

  resetCurrentReport() {
    this.setCurrentReport(null)
  }

  display() {
    const { gov_id, record_type, reports_available } = this.props
    const { currentReport, reports } = this.state

    if (reports_available.loading) {
      return <Loading>Loading Reports</Loading>
    }

    if (reports.length === 0) {
      return <NoReports />
    }

    return (
      <RenderReport
        setCurrentReport={this.setCurrentReport}
        resetCurrentReport={this.resetCurrentReport}
        currentReport={currentReport}
        gov_id={gov_id}
        record_type={record_type}
        reports={reports}
      />
    )
  }

  render() {
    return <Card>{this.display()}</Card>
  }
}

export default LocalAsyncStore(
  'reports_available',
  ProviderLevelReportsWrapper,
  ({ gov_id }) => `/api/providers/${gov_id}/provider-reports`
)



// WEBPACK FOOTER //
// ./src/provider-level/reports/index.js